<template>
  <v-card style="max-height: calc(100vh - 120px); overflow-y: auto">
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Dati Aggiuntivi </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="setCommessaExtra()" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text v-if="rows" :key="key_render">
      <v-container fluid>
        <!-- Riga -->
        <v-row v-for="(row, i) in rows" :key="i">
          <!-- Colonna -->
          <v-col
            align="center"
            :cols="column.fields"
            justify="center"
            :key="j"
            v-for="(column, j) in row.componenti"
          >
            <v-toolbar color="indigo" dense v-if="column.text === 'toolbar'">
              <v-toolbar-title class="white--text">
                <span
                  :style="{
                    fontWeight: column.visible == 1 ? 'bold' : 'normal',
                  }"
                >
                  {{ column.tooltip }}
                </span>
              </v-toolbar-title>
            </v-toolbar>

            <!-- Componente textarea -->
            <v-textarea
              color="black"
              dense
              hide-details
              :label="column.tooltip"
              style="border: 1px solid black; border-radius: 0px"
              v-if="column.text === 'textarea'"
              v-model="generic_obj[column.value]"
            ></v-textarea>

            <!-- Componente textfield -->
            <v-text-field
              dense
              hide-details
              :label="column.tooltip"
              v-if="column.text === 'textfield'"
              :type="column.tipo_oggetto"
              v-model="generic_obj[column.value]"
            ></v-text-field>

            <!-- Componente checkbox -->
            <v-checkbox
              dense
              :false-value="0"
              hide-details
              :label="column.tooltip"
              style="display: inline-block"
              :true-value="1"
              v-if="column.text === 'checkbox'"
              v-model="generic_obj[column.value]"
            ></v-checkbox>
            <!-- Componente select -->
            <v-select
              dense
              hide-details
              :items="array_object[column.icona]"
              item-text="des"
              item-value="id_tabella"
              :key="key_render"
              v-if="column.text === 'select'"
              v-model="generic_obj[column.value]"
            >
              <template #label>
                <span class="">{{ column.tooltip }}</span>
                <span @click.stop style="min-width: 500px; pointer-events: all">
                  <Modules
                    v-on:dialogModules="gettabelle"
                    tipo="QC_FAMIGLIA_DOMANDA"
                    nome="Famiglia Domanda"
                    setaction="settabella"
                    getaction="gettabella"
                    controller="Global"
                    :filter="'validita = 1'"
                    :dati="[{ des: '' }]"
                  />
                </span>
              </template>
            </v-select>

            <!-- Componente autocomplete -->
            <v-autocomplete
              dense
              hide-details
              :items="array_object[column.icona]"
              item-text="des"
              item-value="id_tabella"
              :key="key_render"
              v-if="column.text === 'autocomplete'"
              v-model="generic_obj[column.value]"
            >
              <template #label>
                <span class="">{{ column.tooltip }}</span>
                <span @click.stop style="min-width: 500px; pointer-events: all">
                  <Modules
                    v-on:dialogModules="gettabelle"
                    :tipo="column.icona"
                    :nome="column.tooltip"
                    setaction="settabella"
                    getaction="gettabella"
                    controller="Global"
                    :filter="'validita = 1'"
                    :dati="[{ des: '' }]"
                  />
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-card>
</template>
  <script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "CommessaExtra",
  components: {
    Modules: () => import("@/components/TOOLS/Modules"),
    SnackbarQV,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      array_object: new Object(),
      generic_obj: new Object(),
      key_render: 0,
      str_tipi_modules: "",

      // Modal
      overlay: true,

      // Array
      rows: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    getCommessaExtra() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaextra",
          token: localStorage.user_token,
          id_commessa: this.$route.params.id,
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Se c'è un articolo, lo registro.
            if (res.data.result.commessa.length > 0) {
              for (let field in res.data.result.commessa[0]) {
                this.generic_obj[field] = res.data.result.commessa[0][field];
              }
              this.key_render = this.key_render === 0 ? 1 : 0;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    getStruttura() {
      const request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getstruttura",
          token: localStorage.user_token,
          modulo: "COMMESSA_EXTRA",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Resetto i rows.
            this.rows = new Array();
            // Ordino i componenti in base al parametro ordine.
            res.data.componenti.sort((a, b) =>
              a.ordine < b.ordine ? -1 : a.ordine > b.ordine ? 1 : 0
            );

            /* Mi metto da parte i row. Per ogni oggetto, se non ho
             * ancora messo da parte il row che soddisfa il riferimento
             * dell'oggetto, lo creo e lo inserisco nell'array debito.
             * Mentre esamino i componenti preparo anche le variabili di
             * supporto da v-modellare. */
            res.data.componenti.forEach((c) => {
              // Se non c'è già un row come quello che hai bisogno, aggiungilo.
              if (
                this.rows.filter((e) => e.row_number === c.join_fields)
                  .length === 0
              ) {
                this.rows.push({
                  row_number: c.join_fields,
                  componenti: new Array(),
                });
              }

              // Preparo la variabile da v-modellare per questo componente.
              switch (c.text) {
                case "autocomplete":
                  /* Se il componente è una autocomplete,
                   * preparo anche l'array per i suoi items. */
                  this.generic_obj[c.value] = null;
                  this.str_tipi_modules += `'${c.icona}'`;
                  this.array_object[c.icona] = new Array();
                  break;
                case "select":
                  /* Se il componente è una select, preparo
                   * anche l'array per i suoi items. */
                  this.generic_obj[c.value] = null;
                  this.str_tipi_modules += `'${c.icona}'`;
                  this.array_object[c.icona] = new Array();
                  break;
                case "checkbox":
                  this.generic_obj[c.value] = 0;
                  break;
                case "textarea":
                  this.generic_obj[c.value] = "";
                  break;
                case "textfield":
                  if (c.tipo_oggetto === "text") {
                    this.generic_obj[c.value] = "";
                  } else if (c.tipo_oggetto === "number") {
                    this.generic_obj[c.value] = 0;
                  }
                  break;
                case "tooltip":
                  // Se si tratta di una tooltip, non devo fare nulla.
                  break;
                default:
                  break;
              }
            });

            // Popolo gli array con i loro componenti.
            this.rows.forEach((r) => {
              r.componenti = Array.from(
                res.data.componenti.filter(
                  (c) => c.join_fields === r.row_number
                )
              );
            });
            // console.log(this.generic_obj);

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
          return false;
        });
    },
    gettabelle() {
      // Se non ho rows, non faccio nulla.
      if (this.rows.length === 0) {
        return true;
      }

      /* Se ho rows, conto i tipi da chiedere indietro
       * al BE con la chiamata gettabelle. */
      let tipi = 0;

      this.rows.forEach((r) => {
        r.componenti.forEach((c) => {
          if (c.text === "autocomplete") {
            tipi += 1;
          }
        });
      });

      // In base ai tipi che ho contato, lancio una request.
      if (tipi === 0) {
        return true;
      } else if (tipi === 1) {
        return this.gettabelleTipoSingolo();
      } else {
        return this.gettabelleTipoMultiplo();
      }
    },
    gettabelleTipoMultiplo() {
      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: this.str_tipi_modules.replace("''", "','"),
          filter: "validita = 1",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            for (let field in res.data) {
              this.$set(
                this.array_object,
                field,
                JSON.parse(JSON.stringify(res.data[field]))
              );
            }
            this.key_render = this.key_render == 0 ? 1 : 0;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );

          return false;
        });
    },
    gettabelleTipoSingolo() {
      /* Se sono in questa funzione vuol dire che c'è un solo tipo
       * di etichette che mi serve per le mie select / autocomplete. */
      const str_tmp = this.str_tipi_modules.replaceAll("'", "");

      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "gettabella",
          token: localStorage.getItem("user_token"),
          tipo: str_tmp,
          filter: "validita = 1",
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Valorizzo la lista
            this.array_object[str_tmp] =
              res.data != null && res.data != "" ? res.data : [];
            this.key_render = this.key_render == 0 ? 1 : 0;

            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );

          return false;
        });
    },
    setCommessaExtra() {
      // Mi faccio un oggetto modificabile da inserire nella request
      const obj_tmp = JSON.parse(JSON.stringify(this.generic_obj));

      if (obj_tmp.id_commessa_extra == null) {
        obj_tmp.id_commessa_extra = -1;
      }

      obj_tmp.id_commessa = this.$route.params.id;

      // Compongo la request.
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaextra",
          token: localStorage.user_token,
          commessa: [obj_tmp],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.getCommessaExtra();
            this.$refs.SnackbarQV.print(
              "success",
              "Dati salvati con successo!"
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
  },
  created() {},
  async mounted() {
    await this.getStruttura();
    if (this.str_tipi_modules != "") {
      await this.gettabelle();
    }
    console.log(this.$route.params.id);
    this.getCommessaExtra();
  },
};
</script>
  <style scoped>
</style>